import React from 'react'
import ControlledSwitch from 'transfix-form/components/ControlledSwitch/ControlledSwitch'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { useTeamMemberContext } from 'apps/fleet-planner/context/TeamMemberContext'
import { useTeamMemberFormContext } from 'apps/fleet-planner/context/TeamMemberFormContext'

const useStyles = makeStyles({
  toggle: {
    marginLeft: '11px',
  },
})

const ControlledDriverStatusUpdatesSwitch = () => {
  const { toggle } = useStyles()
  const { control } = useTeamMemberFormContext()
  const { selectedTeamMember } = useTeamMemberContext()
  const { smsStatusUpdatesEnabled } = selectedTeamMember || {}

  return (
    <ControlledSwitch
      name='smsStatusUpdatesEnabled'
      control={control}
      SwitchProps={{
        label: 'Enable driver status updated for all loads',
        className: toggle,
        defaultChecked: smsStatusUpdatesEnabled,
      }}
    />
  )
}

export default ControlledDriverStatusUpdatesSwitch
